<template>
  <el-dialog
    width="70%" class="flex items-center justify-center overflow-y-auto" :visible.sync="dialogVisible"
    :title="form_name" :close-on-click-modal="false"
  >
    <div class="h-full">
      <el-container v-loading="dialogLoading">
        <el-main class="pl-1">
          <el-container>
            <el-main class="form-data-content">
              <fm-generate-form
                ref="generateForm"
                readonly
                :data="jsonData"
                :value="editData"
              />
            </el-main>
            <el-footer v-if="query.action === 'todo'" class="border-t" height="50px">
              <el-form v-model="approve_form" class="py-1">
                <el-form-item v-if="comment" label="审批意见">
                  <el-input v-model="approve_form.approve_comment" type="textarea" rows="3" />
                </el-form-item>
                <el-form-item>
                  <el-button type="primary" @click="submitApprove">提交</el-button>
                </el-form-item>
              </el-form>
            </el-footer>
          </el-container>
        </el-main>
        <el-aside style="width: 350px;">
          <div class="w-full h-10 border-b relative">
            <el-tabs active-name="first">
              <el-tab-pane label="流程动态" name="first">
                <div class="block mt-2">
                  <el-timeline v-if="processes.length > 0">
                    <el-timeline-item
                      v-for="process in processes" :key="process.id" :timestamp="process.time"
                      placement="top"
                    >
                      <el-card>
                        <h4>{{ process.comment }}</h4>
                        <p>{{ process.name }} {{ process.action }}</p>
                      </el-card>
                    </el-timeline-item>
                  </el-timeline>
                  <el-empty v-else description="暂无数据" />
                </div>
              </el-tab-pane>
            </el-tabs>
            <span class="absolute top-0 right-0"><el-button type="text"><i class="bi bi-diagram-2" />流程图</el-button></span>
          </div>
        </el-aside>
      </el-container>
    </div>
  </el-dialog>
</template>

<script>

import axios from 'axios'
import zroute from '../../ziggy'

export default {
  components: {},
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    query: {
      type: Object,
      default: () => ({}),
    },
    approve: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      form_name: '',
      dialogVisible: this.visible,
      approve_form: {
        id: '',
        // approve_result: '',
        approve_comment: '',
      },
      processes: [],
      jsonData: {
        'list': [],
        'config': {'labelWidth': 100, 'labelPosition': 'right', 'size': 'small', 'customClass': ''},
      },
      editData: {},
      comment: false,
    }
  },
  computed: {},
  watch: {
    dialogVisible(val) {
      console.log('dialogVisible change', val)
      this.$emit('update:visible', val)
    },
    query: {
      handler(val) {
        this.getDetail()
      },
      deep: true,
      immediate: true,
    },
  },
  created() {
    // this.getDetail()
  },
  methods: {
    submitApprove() {
      this.dialogLoading = true
      this.$refs.generateForm.getData().then(data => {
        this.approve_form.data = data
        axios.post(zroute('app.entry.approve',{
          app_id: this.query.app_id,
          form_id: this.query.form_id,
          entry_id: this.query.entry_id,
        }), this.approve_form).then(res => {
          this.dialogLoading = false
          this.dialogVisible = false
          this.$message.success('提交成功')
          this.getDetail()
        }).catch(err => {
          this.dialogLoading = false
          this.$message.error(err.response.data.message)
        })
        // saveApprove(this.approve_form).then(res => {
        //   this.dialogLoading = false;
        //   this.dialogVisible = false;
        //   this.$message.success('审批成功');
        //   if (res.status === 1) {
        //     this.getQueryData();
        //   } else {
        //     this.$message.error(res.msg);
        //   }
        // }).catch(err => {
        //   this.dialogLoading = false;
        //   this.dialogVisible = false;
        // })
      })
    },
    getDetail() {
      this.dialogLoading = true
      axios.get(zroute('app.entry.detail', {
        app_id: this.query.app_id,
        form_id: this.query.form_id,
        entry_id: this.query.entry_id,
      }),{params: {action: this.query.action}}).then(res => {
        this.dialogLoading = false
        console.log(res)
        this.jsonData = {list: res.data.list, config: res.data.config}
        this.processes = res.data.processes
        this.editData = res.data.values
        this.comment = res.data.comment
        this.form_name = res.data.form.name
      }).catch(err => {
        this.dialogLoading = false
      })
      // getEntryDetail({id: id, type: this.listQuery.type}).then(res => {
      //   this.dialogLoading = false
      //   console.log(res);
      //   this.jsonData = {list: res.data.list, config: res.data.config};
      //   this.processes = res.data.processes;
      //   this.editData = res.data.values
      //   this.comment = res.data.comment;
      // });
    },
    getQueryData() {
      // this.loading = true;
      // queryData(this.listQuery).then(res => {
      //   console.log('queryData', res);
      //   this.loading = false;
      //   this.list = res.data.list
      //   this.total = res.data.total
      // });
    },
  },
}
</script>
<style lang="scss" scoped>
::v-deep .el-dialog {
  .el-dialog__body {
    height: 100%;
  }
  .el-dialog__header {
    padding: 5px 20px;
    height: 40px;
    background-color: #5d9cee;
    .el-dialog__title {
      color: white;
    }
    .el-dialog__headerbtn {
      top: 10px;
      .el-dialog__close {
        color: white;
      }
    }
  }

  .form-data-content {
    margin: 10px;
    padding-right: 20px;
  }

  .process {
    padding: 10px 0;
  }
}
::v-deep .el-dialog {
  height: 100%;
  margin-top: 0 !important;
  margin-bottom: 0 !important;
  overflow-y: hidden;

  .el-dialog__body {
    height: calc(100% - 40px);
  }

  .el-container {
    height: 100%;
  }

  .el-dialog__body {
    padding: 0;
  }

  .el-main {
    padding: 0;
  }

  .el-aside {
    padding: 0 10px;
    background-color: #f4f6f9;
  }

}
</style>
